// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /pool/search.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePoolSearchBody,
  typePoolSearchOutput200,
} from "../../sdk/pool/postPoolSearch";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPoolSearchQueryKey(payload: typePoolSearchBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`query:${JSON.stringify(payload.query)}`);
  if (typeof payload.sportKey !== "undefined") {
    queryKeySegments.push(`sportKey:${JSON.stringify(payload.sportKey)}`);
  }
  if (typeof payload.leagueKey !== "undefined") {
    queryKeySegments.push(`leagueKey:${JSON.stringify(payload.leagueKey)}`);
  }
  if (typeof payload.contestType !== "undefined") {
    queryKeySegments.push(`contestType:${JSON.stringify(payload.contestType)}`);
  }
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return ["post:pool:poolSearch", "svc:pool-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePoolSearchOutput200,
    unknown,
    typePoolSearchOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePoolSearch(
  payload: typePoolSearchBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPoolSearchQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPoolSearch(payload),
    ...resolvedOptions,
  });
}
